module.exports = __webpack_public_path__ + "static/pro-banner4@2x-768ec7fce2e5fcb8f97d319e7b2fb876.jpg";